import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  useCallback,
} from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import ProductPageWithImg from "../productPage/ProductPageWithImg";
import ProductLocationPopUp from "../productPage/ProductLocationPopUp";
import { globalFileServer } from "../../../../axiosInstance";
import { getItemsPerWord, getProductByGtin } from "../../../server/Product";
import { getSales, reloedFunc, changeProdRank } from "../../../server/Product";
import { useDispatch, useSelector } from "react-redux";
import PopUp from "../../containers/PopUp";
import Card from "../card/Card";
import { CategoryUpdate, getBySlug } from "../../../server/Category";
import CategoryHeaderPage from "../CategoryPageHeder";
import ProductAddToShoppingList from "../productPage/ProductAddToShoppingList";
import { setToggleSidebar } from "../../../server/CartsOpen";
import { showAlertWithConfirmCancel } from "../../../server/ShowAlert";
import { render } from "@testing-library/react";
import { FiEdit2, FiSave } from "react-icons/fi";
import { setProducts } from "../../../server/Product";

const CategoryPage = ({
  adminToCustomer,
  setCurrentSubCategory,
  pendingScrollSlug,
  setPendingScrollSlug,
}) => {
  const navigate = useNavigate();
  const dragItem = useRef();
  const dragOverItem = useRef();
  const beforeItem = useRef();
  const { id, FatherId, subId } = useParams();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const {
    currentCategory,
    stationId,
    role,
    refresh,
    reloed,
    items,
    searchString,
    isClientView,
    includeInactive,
  } = useSelector((state) => ({
    categories: state.category.categories,
    currentCategory: state.category.currentCategory,
    filterList: state.displayProduct.filterList,
    items: state.displayProduct.itemsShow,
    reloed: state.displayProduct.reloed,
    searchString: state.displayProduct.searchString,
    refresh: state.productsInCart.refresh,
    role: state.user.role,
    stationId: state.user.stationId,
    isClientView: state.category.isClientView,
    includeInactive: state.category.includeInactive,
  }));
  const [itemsShow, setItemsShow] = useState(items);
  const [selectedProd, setSelectedProd] = useState([]);
  const [productPopUp, setProductPopUp] = useState(null);
  const [productLocationPopUp, setProductLocationPopUp] = useState(null);
  const [addToShopListPopUp, setAddToShopListPopUp] = useState(null);
  const [countPage, setCountPage] = useState(30);
  const [pagePlace, setPagePlace] = useState(0);
  const observerRef = useRef(null);
  const loadingRef = useRef(false);
  const [renamingCardId, setRenamingCardId] = useState(null);
  const [renameInputValue, setRenameInputValue] = useState("");
  const [updatedCategories, setUpdatedCategories] = useState([]);
  const [parentCtegory, setParentCtegory] = useState(null);

  useEffect(() => {
    setItemsShow(items);
  }, [items]);

  useEffect(() => {
    setParentCtegory(currentCategory);
  }, [currentCategory]);

  useEffect(() => {
    if (!pendingScrollSlug) return;
    setCurrentSubCategory(null);
    setPagePlace((p) => p + 2);
  }, [pendingScrollSlug, reloed]);

  useEffect(() => {
    if (!pendingScrollSlug || reloed) return;

    const el =
      document.querySelector(`[data-category-id="${pendingScrollSlug}"]`) ||
      document.querySelector(
        `[data-parent-category-id="${pendingScrollSlug}"]`,
      );
    if (el) {
      setPendingScrollSlug(null);
      setCurrentSubCategory(pendingScrollSlug);
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      setPagePlace((p) => p + 2);
    }
  }, [pagePlace]);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const categoryId = entry.target.dataset.categoryId;
          const parentId = entry.target.dataset.parentCategoryId;
          const familyCat = entry.target.dataset.family;

          if (!categoryId) return;

          if (categoryId === parentCtegory?.slug) return;

          if (
            familyCat === "true" ||
            parentCtegory?.children.find((cat) => cat.slug === parentId)
          )
            setCurrentSubCategory(parentId);
          else setCurrentSubCategory(categoryId);
        });
      },
      {
        rootMargin: "-40% 0px -40% 0px",
        threshold: 0,
      },
    );

    return () => observerRef.current?.disconnect();
  }, [parentCtegory]);

  const observeSubCategories = useCallback(() => {
    const anchors = document.querySelectorAll("[data-category-id]");
    anchors.forEach((el) => observerRef.current?.observe(el));
  }, []);
  const isGtin = (input) => {
    const s = input.trim();

    if (![8, 12, 13, 14].includes(s.length)) return false;
    if (!/^\d+$/.test(s)) return false;

    return hasValidGs1CheckDigit(s);
  };

  const hasValidGs1CheckDigit = (gtin) => {
    const len = gtin.length;
    const checkDigit = Number(gtin[len - 1]);

    let sum = 0;
    let weight = 3;

    for (let i = len - 2; i >= 0; i--) {
      sum += Number(gtin[i]) * weight;
      weight = weight === 3 ? 1 : 3;
    }

    const expected = (10 - (sum % 10)) % 10;
    return expected === checkDigit;
  };

  const handleScroll = useCallback(() => {
    if (loadingRef.current) return;

    const bottom =
      (window.innerHeight + window.scrollY) * 1.2 >=
      document.documentElement.scrollHeight;

    if (bottom) {
      loadingRef.current = true;
      setPagePlace((prev) => prev + 1);

      setTimeout(() => {
        loadingRef.current = false;
      }, 300);
    }

    observeSubCategories();
  }, [pagePlace, observeSubCategories]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    observeSubCategories();
  }, [pagePlace, observeSubCategories]);

  useEffect(() => {
    getItems();
  }, [pathname, searchString]);

  useEffect(() => {
    if (!stationId || !id) return;
    getBySlug(stationId, id, isClientView, includeInactive)
      .then((res) => {
        if (res) dispatch(setProducts(res));
      })
      .catch((err) => {
        if (err.name !== "AbortError") console.error(err);
      });
  }, [stationId, id, isClientView, includeInactive, dispatch]);

  useEffect(() => {

  }, [isClientView, includeInactive]);

  const getItems = () => {
    // getAllPerCategoryId(id).then((x) => setAdvertising(x.data));
    if (pathname === "/search" && searchString) {
      // dispatch(getItemsPerWord(searchString, stationId));
      dispatch(reloedFunc());
      if (isGtin(searchString)) {
        dispatch(
          getProductByGtin(searchString, stationId === 1 ? 678430 : stationId),
        );
      } else {
        dispatch(
          getItemsPerWord(
            searchString,
            stationId === 1 ? 678430 : stationId,
            "gtin,name,variant,status,brand,sub_brand,user_company,media,description,kosher_supervision,weight_details,weight_jump",
          ),
        );
      }
      setItemsShow(items);
    } else if (pathname === "/sales") {
      dispatch(reloedFunc());
      dispatch(getSales(stationId));
    }
  };

  useEffect(() => {
    if (pathname.includes("/category")) {
      setCurrentSubCategory(null);
    }
  }, [id, pathname, searchString, refresh]);

  useEffect(() => {
    getItems();
  }, [stationId]);

  const sortItems = async () => {
    const { current: dragInfo } = dragItem;
    const { current: overInfo } = dragOverItem;
    const { current: beforeInfo } = beforeItem;

    let positionData = { kind: "append" };

    if (beforeInfo.prod && overInfo.prod) {
      positionData = {
        kind: "betweenById",
        after: overInfo.prod.productId,
        before: beforeInfo.prod.productId,
      };
    } else if (beforeInfo.prod) {
      positionData = { kind: "prepend" };
    }

    const payload = {
      branch: stationId,
      position: positionData,
    };

    showAlertWithConfirmCancel({
      msgTitle: "האם לעדכן את סדר הפריטים?",
      confirmText: "אישור",
      cancelText: "ביטול",
      onConfirm: async () => {
        try {
          await changeProdRank(dragInfo.cat, dragInfo.prod.productId, payload);
          const newItemsState = JSON.parse(JSON.stringify(itemsShow));
          updateLocalStateRecursive(newItemsState, dragInfo.cat, dragInfo.prod);
          setItemsShow(newItemsState);
        } catch (error) {
          console.error("Update failed:", error);
        }
      },
    });
  };

  const updateLocalStateRecursive = (node, targetCat, draggedProd) => {
    if (node.slug === targetCat) {
      node.products = node.products.filter(
        (p) => p.productId !== draggedProd.productId,
      );
      const newIndex = dragOverItem.current.pos;
      node.products.splice(newIndex, 0, draggedProd);
      return true;
    }

    if (node.children) {
      for (let child of node.children) {
        if (updateLocalStateRecursive(child, targetCat, draggedProd))
          return true;
      }
    }
    return false;
  };

  useEffect(() => {
    getItems();
  }, [adminToCustomer]);

  const startRenamingCard = (card) => {
    setRenamingCardId(card.id);
    setRenameInputValue(getCategoryName(card));
  };

  const saveRenamingCategory = (cat) => {
    dispatch(
      CategoryUpdate(
        {
          Mkt: cat.id,
          Title: "name",
          value: renameInputValue,
          slug: cat.slug,
        },
        stationId,
      ),
    )
      .then(() => {
        setUpdatedCategories([
          ...updatedCategories.filter((c) => c.id !== cat.id),
          { id: cat.id, name: renameInputValue },
        ]);
      })
      .catch((error) => {
        console.error("Error renaming category:", error);
      });
    setRenamingCardId(null);
  };

  const getCategoryName = (node) => {
    const isUpadated = updatedCategories.find((cat) => cat.id === node.id);
    return isUpadated ? isUpadated.name : node.name;
  };

  const maxItemsToRender = countPage * (pagePlace + 1);
  let renderedItemsCount = 0;

  const renderCategoryNode = (node) => {
    if (!node || renderedItemsCount >= maxItemsToRender) return null;

    let categoryHasRenderedProducts = false;
    const renderedProducts = [];

    if (node.products && node.products.length) {
      for (let i = 0; i < node.products.length; i++) {
        if (renderedItemsCount >= maxItemsToRender) break;

        const element = node.products[i];
        renderedItemsCount++;
        categoryHasRenderedProducts = true;

        renderedProducts.push(
          <Fragment key={element.productId}>
            {element.type === "advertising" ? (
              <div>
                <div className="img" onClick={() => navigate(element.Url)}>
                  <img
                    loading="lazy"
                    src={`${globalFileServer}Advertising/${element.PathUrl}`}
                    alt={element.CategoryName}
                  />
                </div>
                {element.type}
              </div>
            ) : (
              <div
                className="col-lg-2"
                data-category-id={node.slug}
                data-parent-category-id={node.parentSlug}
                data-family={node.isFamily}
                onDragStart={() => {
                  dragItem.current = { prod: element, cat: node.slug, pos: i };
                }}
                onDragEnter={() => {
                  dragOverItem.current = {
                    prod:
                      dragItem.current.pos < i ? element : node.products[i - 1],
                    cat: node.slug,
                    pos: i,
                  };
                  beforeItem.current = {
                    prod:
                      dragItem.current.pos < i ? node.products[i + 1] : element,
                    cat: node.slug,
                  };
                }}
                onDragEnd={role ? sortItems : null}
                draggable
              >
                <Card
                  element={element}
                  familyProd={node.isFamily}
                  productPopUp={() => {
                    setProductPopUp(true);
                    setSelectedProd(element);
                    dispatch(setToggleSidebar(false));
                  }}
                  addToShopListPopUp={() => {
                    setAddToShopListPopUp(true);
                    setSelectedProd(element);
                  }}
                  productLocationPopUp={() => {
                    setProductLocationPopUp(true);
                    setSelectedProd(element);
                    dispatch(setToggleSidebar(false));
                  }}
                />
              </div>
            )}
          </Fragment>,
        );
      }
    }

    const renderedChildren = [];
    if (
      node.children &&
      node.children.length &&
      renderedItemsCount < maxItemsToRender
    ) {
      for (let i = 0; i < node.children.length; i++) {
        if (renderedItemsCount >= maxItemsToRender) break;
        const child = renderCategoryNode(node.children[i]);
        if (child) renderedChildren.push(child);
      }
    }

    if (!categoryHasRenderedProducts && renderedChildren.length === 0) {
      return null;
    }

    return (
      <Fragment key={node.id}>
        {id !== node.slug && !node.isFamily && renderedProducts.length > 0 && (
          <div className="category-name">
            <h1>{node.name}</h1>
          </div>
        )}
        {node.isFamily && (
          <div className="category-name">
            {renamingCardId === node.id ? (
              <form
                className="rename-form"
                onSubmit={() => saveRenamingCategory(node)}
              >
                <input
                  type="text"
                  value={renameInputValue}
                  onChange={(e) => setRenameInputValue(e.target.value)}
                  className="rename-input"
                  autoFocus
                  aria-label="Rename category"
                />
                <button
                  type="submit"
                  className="icon-button"
                  aria-label="Save new name"
                >
                  <FiSave size={20} />
                </button>
                <span className="family-price" dir="rtl">
                  {
                    renderedProducts[0].props?.children?.props?.children?.props
                      ?.element?.pricing?.price
                  }{" "}
                  ₪
                </span>
              </form>
            ) : (
              <h1>
                {getCategoryName(node)}
                {role && (
                  <button
                    className="icon-button"
                    onClick={() => startRenamingCard(node)}
                  >
                    <FiEdit2 size={20} />
                  </button>
                )}
                <span className="family-price" dir="rtl">
                  {
                    renderedProducts[0].props?.children?.props?.children?.props
                      ?.element?.pricing?.price
                  }{" "}
                  ₪
                </span>
              </h1>
            )}
          </div>
        )}
        <>{renderedProducts}</>
        {renderedChildren}
      </Fragment>
    );
  };

  if (
    currentCategory?.children.length ||
    pathname === "/search" ||
    pathname === "/sales" ||
    pathname.startsWith("/category")
  ) {
    return (
      <div className="products-view">
        <CategoryHeaderPage id={id} FatherId={FatherId} subId={subId} />

        {productPopUp ? (
          <ProductPageWithImg
            selectedProd={selectedProd}
            close={() => setProductPopUp(!productPopUp)}
          />
        ) : null}
        {addToShopListPopUp ? (
          <PopUp width="500px" close={() => setAddToShopListPopUp(false)}>
            <ProductAddToShoppingList
              selectedProd={selectedProd}
              close={() => setAddToShopListPopUp(false)}
            />
          </PopUp>
        ) : null}
        {productLocationPopUp ? (
          <PopUp
            width="900px"
            close={() => setProductLocationPopUp(!productLocationPopUp)}
          >
            <h3>{selectedProd.ProductName}</h3>
            <ProductLocationPopUp product={selectedProd} />{" "}
            <div
              onClick={() => setProductLocationPopUp(!productLocationPopUp)}
              className="overflow"
            ></div>
          </PopUp>
        ) : null}
        {pathname === "/search" ? (
          <h1 className="search-title">חיפוש מוצרים</h1>
        ) : null}
        {pathname === "/sales" ? (
          <h1 className="search-title">מוצרי מבצע</h1>
        ) : null}

        <div className="flex-container">
          <div className="col-lg-9 category-card">
            {reloed ? (
              <h1>טוען מוצרים...</h1>
            ) : items?.length !== 0 ? (
              <> {renderCategoryNode(itemsShow)}</>
            ) : (
              <h1>אין מוצרים במלאי</h1>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default CategoryPage;
